// function getEnv() {
//   const currentUrl = window.location.href;
//   if (currentUrl.includes('deveusw1.americanexpress.com'))
//     return 'e1';
//   else if (currentUrl.includes('qaeusw1.americanexpress.com'))
//     return 'e2';
//   else if (currentUrl.includes('.americanexpress.com'))
//     return 'e3';
//   else return 'e1';
// }

// module.exports = {
//   getEnv: getEnv
// }
function getEnv() {
  const currentUrl = window.location.href;
  if (currentUrl.includes('deveusw1.americanexpress.com'))
    return 'e1';
  else if (currentUrl.includes('qaeusw1.americanexpress.com'))
    return 'e2';
  else if (currentUrl.includes('.americanexpress.com'))
    return 'e3';
  else return 'e1';
}

// Named export for direct import
export { getEnv };

// Default export for compatibility
export default {
  getEnv: getEnv
}